import { makeAutoObservable, runInAction } from 'mobx'

import { serverMessage } from '@/Ship/Helpers/serverError'

import { GMAIL_APP_PASSWORD_LENGTH } from '../Contracts/IUser'
import { PatchUserTask } from '../Tasks/PatchUserTask'

export const GMAIL_PASSWORD_TEXTS = {
    set: 'Пароль задано.',
    unset: 'Пароль не задано.',
    length: `Пароль додатку Google Workspace має містити рівно ${GMAIL_APP_PASSWORD_LENGTH} символів.`,
    saved: 'Пароль Google Workspace збережено.',
} as const

/**
 * Вкладка «Пароль Google Workspace» (С3.1, D-04): пароль лише записується.
 * Назовні бек віддає тільки `hasGmailAppPassword` — його й показуємо.
 */
export class UserGmailPasswordManager {
    hasPassword: boolean
    isLoading = false
    error: string | null = null

    constructor(hasPassword: boolean) {
        this.hasPassword = hasPassword
        makeAutoObservable(this)
    }

    /**
     * `true` — збережено, поле можна очищати. Довжину перевіряємо до запиту:
     * пробіли, якими Google розбиває пароль на групи, — частина значення й
     * рахуються (П-5), як і на беку.
     */
    async submit(uuid: string, value: string): Promise<boolean> {
        if (value.length !== GMAIL_APP_PASSWORD_LENGTH) {
            this.error = GMAIL_PASSWORD_TEXTS.length
            return false
        }

        this.isLoading = true
        this.error = null

        try {
            const response = await PatchUserTask(uuid, { gmailAppPassword: value })

            runInAction(() => {
                this.hasPassword = typeof response.hasGmailAppPassword === 'boolean' ? response.hasGmailAppPassword : true
            })

            return true
        } catch (error) {
            runInAction(() => {
                this.error = serverMessage(error, 'Не вдалося зберегти пароль Google Workspace.')
            })

            return false
        } finally {
            runInAction(() => {
                this.isLoading = false
            })
        }
    }
}
